import { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import ButtonIcon from 'src/ui/atoms/Button/Icon'
import useOnClickOutside from 'src/hooks/useOnClickOutside'
import useHeaderApi from './useHeaderApi'
import { useAuthState } from 'src/contexts/authContext'

const UserProfileDropdown = () => {
  const navigate = useNavigate()
  const { logout } = useHeaderApi()

  const [open, setOpen] = useState(false)
  const elRef = useRef<HTMLDivElement>(null)
  const authState = useAuthState()

  useOnClickOutside(elRef, () => {
    setOpen(false)
  })

  const handleLogOut = async () => {
    try {
      await logout()
      navigate('/login')
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div className="relative">
      <ButtonIcon onClick={() => setOpen(!open)} icon="user" type="alternative" size="S" />
      {open && (
        <div
          ref={elRef}
          className="absolute right-0 top-9 z-20 rounded-xl bg-navy-blue px-6 py-2 shadow-lg">
          {authState.user.email ? (
            <div className="flex flex-wrap whitespace-nowrap text-white">
              <span className="w-100 text-sm">Account email:</span>{' '}
              <span className="text-lg">{authState.user.email}</span>
            </div>
          ) : null}
          <button
            className="flex w-52 cursor-pointer flex-row items-center gap-2 py-2 font-spaceGrotesk text-white hover:text-main-blue"
            onClick={() => handleLogOut()}>
            <span className="icon-exit text-xl" />
            <span className="text-lg"> Logout </span>
          </button>
        </div>
      )}
    </div>
  )
}

export default UserProfileDropdown
